export default "__VITE_ASSET__DKjV0fHg__"